<template>
  <div>
    <page-link v-if="currentPage > 1" @click="$emit('page-click', 1)"
      >First</page-link
    ><page-link
      v-if="currentPage > 1"
      @click="$emit('page-click', currentPage - 1)"
      >Prev</page-link
    ><page-link
      v-for="page in pages"
      :key="page"
      :selected="page == currentPage"
      @click="$emit('page-click', page)"
      >{{ page }}</page-link
    ><page-link
      v-if="currentPage < count"
      @click="$emit('page-click', currentPage + 1)"
      >Next</page-link
    ><page-link v-if="currentPage < count" @click="$emit('page-click', count)"
      >Last</page-link
    >
  </div>
</template>
<script>
import PageLink from "./PageLink.vue";
import { MAX_LINKS } from "@/constants/pagination";

const pages = function() {
  let start = 1;
  let links = [];
  const upperBound = this.count > MAX_LINKS ? MAX_LINKS : this.count;

  if (this.currentPage < upperBound / 2 + 1) {
    start = 1;
  } else if (this.currentPage >= this.count - upperBound / 2) {
    start = Math.floor(this.count - upperBound + 1);
  } else {
    start = this.currentPage - Math.floor(upperBound / 2);
  }

  for (let i = start; i <= start + upperBound - 1; i++) {
    links.push(i);
  }

  return links;
};

export default {
  components: { PageLink },
  props: ["count", "currentPage"],
  emits: ["page-click"],
  computed: {
    pages,
  },
};
</script>
